<template>
  <div>
    <firstPage></firstPage>
    <secondPage></secondPage>
    <thirdPage></thirdPage>
    <fourthPage></fourthPage>
    <fifthPage></fifthPage>
    <sixthPage></sixthPage>
    <seventhPage></seventhPage>
    <eighthPage></eighthPage>
    <ninthPage></ninthPage>
    <tenthPage></tenthPage>
    <footerPage></footerPage>

  </div>
</template>

<script>
import firstPage from "@/components/firstPage.vue";
import secondPage from "@/components/secondPage.vue";
import thirdPage from "@/components/thirdPage.vue";
import fourthPage from "@/components/fourthPage.vue";
import fifthPage from "@/components/fifthPage.vue";
import sixthPage from "@/components/sixthPage.vue";
import seventhPage from "@/components/seventhPage.vue";
import eighthPage from "@/components/eighthPage.vue";
import ninthPage from "@/components/ninthPage.vue";
import tenthPage from "@/components/tenthPage.vue";
import footerPage from "@/components/footerPage.vue";

export default {
  name: "Home",
  components: {
    firstPage,
    secondPage,
    thirdPage,
    fourthPage,
    fifthPage,
    sixthPage,
    seventhPage,
    eighthPage,
    ninthPage,
    tenthPage,
    footerPage,
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue